import { t } from 'i18next';
import type { Abtests, Auth, ReturnLinks, SignInPayload } from '../../types';
import { STORAGE_KEY, config } from '../config';
import { redirectMap } from '../routes/redirectMap';
import { getJSONItem, setItem } from '../services/storage/storage';
import api from '../services/api/api';

const authImplementation: Auth = {
  user: getJSONItem(STORAGE_KEY.USER, {}),
  abtest: '',
  async signin({ username, password }: SignInPayload, callbackSuccess: VoidFunction, callbackFail: VoidFunction) {
    const { error, link } = await api.signin({ user: username, password });
    if (error === 0) {
      const session = await api.getSession();
      const abtest: Abtests = config.abtest || 'guest';
      // redirect se la platformnon matcha e dobbiamo fare redirect, altrimenti navigate di react-router
      const { redirect, navigate } = redirectMap?.[abtest]?.[link as ReturnLinks] || { redirect: '/', navigate: '/' };
      authImplementation.user = {
        ...authImplementation.user,
        session: session?.data?.[0],
        isAuthenticated: true,
        matchPlatform: !!navigate,
        loginSuccessUrl: redirect ? redirect : navigate,
        username,
      };
      setItem(STORAGE_KEY.USER, authImplementation.user);
      callbackSuccess();
    } else {
      callbackFail();
    }
  },
  async signout(callbackSuccess: VoidFunction) {
    const response = await api.signout();
    if (response.error === 503) {
      setTimeout(callbackSuccess, 100);
    } else {
      console.error('Error on logout');
    }
    authImplementation.user = { session: null, isAuthenticated: false, username: null };
    setItem(STORAGE_KEY.USER, authImplementation.user);
  },
  async forgot({ email, cf }, callbackSuccess: VoidFunction, callbackFail: (errorType: number) => void) {
    const response = await api.forgot({ email, cf });
    if (response.error === -1) {
      callbackFail(response.error);
      console.error(response);
    } else {
      callbackSuccess();
    }
  },
  async help({ fullName, email, subject, message }, callbackSuccess, callbackFail) {
    const response = await api.help({
      fullName: encodeURIComponent(fullName),
      email: encodeURIComponent(email),
      subject: encodeURIComponent(subject),
      message: encodeURIComponent(`${message}<div>[${t('helpdesk')}]</div>`),
    });
    if (response.status === 200 && response.error === 0) {
      callbackSuccess();
    } else {
      console.error('Error on help');
      callbackFail();
    }
  },
  async forgotSms({ email, cf }, callbackSuccess: VoidFunction, callbackFail: (errorType: number) => void) {
    const response = await api.forgotSms({ email, cf });
    if (response.status === 200 && response.success) {
      callbackSuccess();
    } else {
      callbackFail(response.message);
      console.error(response);
    }
  },
};

export default authImplementation;
